(function certificateEditControllerDefinition() {
    'use strict';

    angular.module('Certificate')
        .controller('CertificateEditController', [
            '$filter', '$state', '$scope', '$stateParams', '$translate', 'alerts', 'errorsExtend', 'processCustomerService', 'fileWorkflowService', 'authExtend', 'configViewService', '$q',
            function certificateEditController($filter, $state, $scope, $stateParams, $translate, alerts, errors, processCustomerService, fileWorkflowService, auth, configViewService, $q) {

                $scope.preview = {
                    closed: true,
                    loading: false,
                    content: null,
                    index: null,
                    item: null,
                    invalid: false
                };

                $scope.tmpProcess = {
                    name: '',
                    metadatas: []
                };

                $scope.loadCertificate = function () {
                    return processCustomerService.checkout($stateParams.id).then(function (result) {
                        $scope.certificate = result;
                    }, function (error) {
                        errors.showError(error);
                        $scope.cancel();
                    });
                };

                $scope.loadConfigView = function () {
                    return configViewService.getById("CPPCertificate").then(function (result) {
                        $scope.configView = result;
                    }, function (error) {
                        errors.showError(error);
                        $scope.cancel();
                    });
                };

                $scope.loadFile = function (fileId) {
                    return fileWorkflowService.getById(fileId)
                };

                $scope.cancel = function () {
                    $state.go('certificate-find');
                };

                $scope.save = function () {
                    if (!$scope.certificateEdit.$valid) {
                        $scope.certificateEdit.$setSubmitted();
                        errors.showError('VerifyFormData');
                        return false;
                    }

                    $scope.tmpProcess.metadatas.forEach(function (tmpProcessMetadata) {
                        var metadataFound = $filter('filter')($scope.certificate.metadataValues, { metadataId: tmpProcessMetadata.metadataId }, true);

                        if (metadataFound.length > 0) {
                            metadataFound[0].value = tmpProcessMetadata.metadataValue;
                        } else {
                            $scope.certificate.metadataValues.push({
                                metadataId: tmpProcessMetadata.metadataId,
                                name: tmpProcessMetadata.metadataLabel,
                                isRequired: tmpProcessMetadata.metadataIsRequired,
                                isVisible: tmpProcessMetadata.metadataIsVisible,
                                order: tmpProcessMetadata.order,
                                systemName: tmpProcessMetadata.systemName,
                                type: tmpProcessMetadata.metadataType,
                                value: tmpProcessMetadata.metadataValue
                            });
                        }
                    });

                    return processCustomerService.modifyAndSend($scope.certificate).then(function () {
                        $state.go('certificate-find');
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.load = function () {
                    $scope.userId = auth.getUserId();
                    var metadatas = [];

                    $q.all([$scope.loadCertificate(), $scope.loadConfigView()]).then(function () {
                        var result = $filter('filter')($scope.configView.processTypes, { processTypeId: $scope.certificate.certificateTypeId }, true);
                        if (result.length == 0) {
                            $scope.certificate.metadataValues = metadatas;
                            return;
                        }

                        $scope.legend = $scope.configView.legends[0];

                        result[0].metadatas.forEach(function (certificateMetadata) {
                            if (certificateMetadata.editCriteria) {
                                var metadataFound = $filter('filter')($scope.certificate.metadataValues, { systemName: certificateMetadata.systemName }, true);

                                var value = null;
                                var desc = null;

                                if (metadataFound.length > 0) {
                                    value = metadataFound[0].value;
                                    desc = metadataFound[0].description;
                                }
                                $scope.tmpProcess.metadatas.push({
                                    idObject: $scope.certificate.id + '' + certificateMetadata.metadataId,
                                    metadataId: certificateMetadata.metadataId,
                                    metadataType: certificateMetadata.systemName == '_cpassword' && $scope.certificate.stateId == '204' ? 'password' : certificateMetadata.metadataType.toLowerCase(),
                                    metadataLabel: certificateMetadata.editCriteria.name,
                                    metadataIsRequired: certificateMetadata.editCriteria.isRequired,
                                    metadataIsVisible: true,
                                    metadataReadOnly: !certificateMetadata.editCriteria.isEditable,
                                    metadataEnabled: certificateMetadata.editCriteria.isEditable,
                                    maskOptions: certificateMetadata.maskOptions,
                                    metadataValue: value,
                                    metadataOptions: certificateMetadata.metadataOptionValues,
                                    systemName: certificateMetadata.systemName,
                                    order: certificateMetadata.editCriteria.order,
                                    metadataToolTip: certificateMetadata.editCriteria.toolTip
                                });
                            }
                        });

                        $scope.tmpProcess.metadatas.sort(function (a, b) {
                            return a.order - b.order;
                        });

                        $scope.certificate.name = $scope.certificate.name;

                    });
                };

                $scope.load();
            }
        ]);
})();
